import React, { Component, Fragment } from "react";

import "./CustomDropDownInput.css";

const data1 = [
  { value: "", name: "" },
  { value: "value", name: "name" },
  { value: "sar_connor", name: "john_connor sasdsdsd" },
  { value: "john_connor", name: "john_connor" },
  { value: "john_connor", name: "john_connor" }
];
export class CustomDropDownInput extends Component {
  constructor() {
    super();
    this.state = { selectedValue: "", };

    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    this.props.onChangeEvent(event.target.value);
  }
  render() {
    const {
      data = data1,
      errorMsg = "errorMsg",
      flag = false,
      disabled = false,
      id = "customDropDown",
      // value,
      name,
      FirstValue="",
      FirstName = FirstValue,
    } = this.props;
    return (
      <Fragment>
        <div className="custom_drop_down_input_container">
          <select
            id={id}
            className="custom_drop_down_input"
            disabled={disabled}
            onChange={this.onChange}
          >
           <option value={FirstValue}>{FirstName}</option>
            {data.map((item, index) => {
              return (
                <option value={JSON.stringify(item)} key={id.length ? item[id] : index}>
                  {item[name]}
                </option>
              );
            })}
          </select>
          <i className="material-icons custom_drop_down_icon">expand_more</i>
        </div>
        <p
          className="custom_drop_down_input_error_text"
          style={{ visibility: flag ? "visible" : "hidden" }}
        >
          {errorMsg}
        </p>
      </Fragment>
    );
  }
}

export default CustomDropDownInput;
